import { formatCPF } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { ChevronRight, AlertTriangle, Clock } from "lucide-react";

function fmtHora(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("pt-BR", { timeZone: "America/Fortaleza" });
  } catch { return iso; }
}

function minutosAte(iso) {
  if (!iso) return null;
  const diff = (new Date(iso).getTime() - Date.now()) / 60000;
  return Math.max(0, Math.round(diff));
}

export function NovasInscricoesList({ items, seenAt, onOpen }) {
  if (!items.length) {
    return (
      <div className="p-6 text-center text-xs text-slate-500">
        Nenhuma inscrição nas últimas 24h.
      </div>
    );
  }
  return items.map((it) => {
    const nova = !seenAt || new Date(it.created_at).getTime() > new Date(seenAt).getTime();
    return (
      <button
        key={it.id}
        onClick={() => onOpen(it.id)}
        className={`w-full text-left p-3 border-b hover:bg-slate-50 transition-colors ${nova ? "bg-blue-50/60" : ""}`}
        data-testid={`alert-nova-${it.id}`}
      >
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0 flex-1">
            <div className="text-xs font-mono text-slate-500">{it.protocolo}</div>
            <div className="text-sm font-semibold text-slate-800 truncate">
              {it.nome_completo}
            </div>
            <div className="text-xs text-slate-500">
              {formatCPF(it.cpf)} · {it.bairro || "—"}
            </div>
          </div>
          <div className="flex flex-col items-end gap-1 shrink-0">
            {nova && <Badge className="bg-blue-500 text-white text-[9px] h-4">NOVA</Badge>}
            <ChevronRight className="w-4 h-4 text-slate-400" />
          </div>
        </div>
        <div className="text-[11px] text-slate-400 mt-0.5">{fmtHora(it.created_at)}</div>
      </button>
    );
  });
}

export function DocumentosPendentesList({ items, onOpen }) {
  if (!items.length) {
    return (
      <div className="p-6 text-center text-xs text-slate-500">
        Nenhuma inscrição com docs obrigatórios faltando.
      </div>
    );
  }
  return items.map((it) => (
    <button
      key={it.id}
      onClick={() => onOpen(it.id)}
      className="w-full text-left p-3 border-b hover:bg-amber-50/60 transition-colors"
      data-testid={`alert-doc-${it.id}`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <div className="text-xs font-mono text-slate-500">{it.protocolo}</div>
          <div className="text-sm font-semibold text-slate-800 truncate">
            {it.nome_completo}
          </div>
          <div className="text-xs text-amber-800 mt-1">
            <AlertTriangle className="w-3 h-3 inline mr-0.5" />
            Faltando: {it.faltando.join(", ")}
          </div>
        </div>
        <ChevronRight className="w-4 h-4 text-slate-400 shrink-0" />
      </div>
    </button>
  ));
}

export function OtpsExpirandoList({ items, onOpen }) {
  if (!items.length) {
    return (
      <div className="p-6 text-center text-xs text-slate-500">
        Nenhum OTP de transferência expirando em 2h.
      </div>
    );
  }
  return items.map((it) => {
    const min = minutosAte(it.otp_expira);
    return (
      <button
        key={it.id}
        onClick={() => onOpen(it.inscricao_id)}
        className="w-full text-left p-3 border-b hover:bg-red-50/60 transition-colors"
        data-testid={`alert-otp-${it.id}`}
      >
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0 flex-1">
            <div className="text-xs font-mono text-slate-500">{it.protocolo}</div>
            <div className="text-sm font-semibold text-slate-800 truncate">
              {it.from_nome} → {it.to_nome}
            </div>
            <div className="text-xs text-red-700 mt-1 flex items-center gap-1">
              <Clock className="w-3 h-3" /> Expira em {min} min · motivo: {it.motivo}
            </div>
          </div>
          <ChevronRight className="w-4 h-4 text-slate-400 shrink-0" />
        </div>
      </button>
    );
  });
}

export { fmtHora };
